import React from 'react';
import styled from 'styled-components';
import { Field } from 'redux-form';

const Label = styled.label`
  & > input[type='radio'] {
    display: none;
  }
`;

const Item = styled.div`
  display: flex;
  align-items: center;
  height: 49px;
  margin: 0px 60px;
  font-size: 14px;
  color: ${props => props.theme.secondary};
  fill: ${props => props.theme.primary};
  border-bottom: solid 1px ${props => props.theme.primaryAlt};

  input[type='radio']:checked + & {
    color: ${props => props.theme.onPrimary};
    fill: ${props => props.theme.onPrimary};
    background: ${props => props.theme.primary};
  }
`;
const IconWrapper = styled.span`
  margin-left: 85px;
`;

const Span = styled.span`
  ${({ center }) => (center ? 'margin: auto;' : 'margin-left: 20px;')};
`;

const RadioField = ({ icon: Icon, label, textCapitalize, ...other }) => (
  <Label>
    <Field {...other} />
    <Item>
      {Icon && (
        <IconWrapper>
          <Icon />
        </IconWrapper>
      )}
      {textCapitalize ? (
        <Span style={{ textTransform: 'capitalize' }} center={!Icon}>
          {label}
        </Span>
      ) : (
        <Span center={!Icon}>{label}</Span>
      )}
    </Item>
  </Label>
);

export default RadioField;
